import React from 'react';
import { contexts } from 'lib_ui-primitives';
import useEventSink from '../../hooks/useEventSink';

const rc = React.createElement;

export const { EventBoundaryContext } = contexts;

// Inspired by https://kentcdodds.com/blog/how-to-use-react-context-effectively
// See useEventSink for the other half of this.
export default function EventBoundaryProvider(props) {
    const {
        children,
        logEvents,
        bubbleUpEvents = true,
        name,
        defaultContext = false,
        subscriptions = {}
    } = props || {};
    const parentSink = useEventSink(!bubbleUpEvents);
    const context = {
        name,
        subscriptions,
        logEvents,
        parentSink: bubbleUpEvents ? parentSink : null,
        defaultContext
    };
    return rc(EventBoundaryContext.Provider, { value: context }, children);
}
